// ofuro-wiki: No AI feature
export const useEnableAI = () => {
  return false;
};
